module.exports = __webpack_public_path__ + "assets/img/3-4.0ff1133b.png";